'use client';

import { useState } from 'react';
import Image from 'next/image';

import { navigate, VideoCard } from '@widgets/Landing';
import { Button } from '@shared/ui/components';
import NoraRound from '@public/images/nora-round.svg';
import ArrowIcon from '@public/icons/arrow-right.svg';
import Logo from '@public/logo.svg';
import LogoFull from '@public/logo-full.svg';

import styles from './QEDUPlatform.module.scss';

export default function QEDUPlatform() {
  const [showMore, setShowMore] = useState<boolean>(false);

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <Image src={NoraRound} className={styles.nora_1_mobile} alt="Round" draggable={false} />
        <Image src={NoraRound} className={styles.nora_2_mobile} alt="Round" draggable={false} />

        <div className={styles.top_header}>
          <Image src={LogoFull} className={styles.top_header_logo} alt="Logo" draggable={false} />
          <div className={styles.top_header_text}>Just know how</div>
        </div>

        <div className={styles.top_body}>
          <div className={styles.top_body_title}>Online Quantum Computing Educational Program</div>

          <div className={styles.top_body_text}>
            Build real-world quantum skills on your terms. You can choose the Personal Assessment
            and then select the Q:EDU program plan that best fits your goals and schedule. Your
            personalised learning environment and many more features will accompany as you learn.
            It&apos;s a hands-on learning approach to sharpen your skill set and &apos;Just Know
            How&apos; Quantum Computing works.
            <br />
            The course &apos; Applied Quantum Computing with Dynex &apos; received Academic
            Accreditation from Sona College of Technology in 2025.
          </div>
        </div>

        <Button
          size="l"
          variant="filled"
          className={styles.button}
          onClick={() => navigate('#plans')}
        >
          <div>Q:EDU Program Plans</div>
          <Image src={ArrowIcon} alt="Arrow" draggable={false} />
        </Button>
      </div>

      <div className={styles.wrapper}>
        <Image src={NoraRound} className={styles.nora_1} alt="Round" draggable={false} />

        <div className={styles.content}>
          <Image src={NoraRound} className={styles.nora_2} alt="Round" draggable={false} />

          <div className={styles.content_header}>
            <VideoCard containerClassName={styles.content_header_video} />

            <div className={styles.content_header_title}>
              <div>About</div>
              <Image src={Logo} alt="Logo" draggable={false} />
            </div>

            <div id="quantum-education" className={styles.content_header_body}>
              <div className={styles.content_header_body_title}>
                <div className={styles.content_header_body_title_title}>Quantum Education</div>
                <div className={styles.content_header_body_title_text}>Where Know How begins</div>
              </div>

              <div className={styles.content_header_body_text}>
                <span className={styles.strong}>Q:EDU</span> is a unique educational program
                platform providing the latest “know-how” needed for the upcoming computing
                requirements. The goal of Q:EDU is to build a partner ecosystem for various
                educational programs that support the transition of knowledge required for the
                application of single and hybrid computational technologies. This will involve HPC
                (High Performance Computing), QC (Quantum Computing), AI (Artificial Intelligence)
                with LLM (Large Language Model) and QdLLM (Quantum Diffusion Large Language Model),
                the World Wide Web with decentralised and blockchain technologies, the token based
                economy (Web 3.0) , etc...
              </div>
            </div>

            <div className={styles.content_header_list}>
              <div className={styles.content_header_list_item}>
                <div className={styles.content_header_list_marker}>
                  <div />
                  <div />
                  <div />
                </div>
                <div>
                  <span className={styles.strong}>Q:EDU</span> is aiming to become one of the
                  leading educational platforms for people to &apos;Just Know How&apos;.
                </div>
              </div>

              <div className={styles.content_header_list_item}>
                <div className={styles.content_header_list_marker}>
                  <div />
                  <div />
                  <div />
                </div>
                <div>
                  <span className={styles.strong}>Q:EDU&apos;s</span> first launched academic
                  educational program in 2025 &apos;Applied Quantum Computing with Dynex&apos;
                  developed by <span className={styles.strong}>Dynex Moonshots</span> in close
                  collaboration with <span className={styles.strong}>Dynex</span> is{' '}
                  <span className={styles.strong}>academically accredited</span> by Sona College of
                  Technology (India).
                </div>
              </div>

              <div className={styles.content_header_list_item}>
                <div className={styles.content_header_list_marker}>
                  <div />
                  <div />
                  <div />
                </div>
                <div>
                  <span className={styles.strong}>Q:EDU</span> is part of a tri - party ecosystem
                  partnership initiative uniting and interconnecting Educational Program Offering
                  with Academia (<span className={styles.strong}>Sona College of Technology</span>)
                  and AI-proctored talent assessment and management platform (
                  <span className={styles.strong}>HireMee</span>) to &apos;Just Know How&apos;.
                </div>
              </div>
            </div>
          </div>

          <div className={styles.content_body}>
            <div id="vision" className={styles.content_body_item}>
              <div className={styles.content_body_item_title}>Vision</div>
              <div className={styles.content_body_item_text}>
                <span className={styles.strong}>Q:EDU</span> is a leading educational program
                platform aiming to build a global ecosystem of partnerships that unite and
                interconnect Educational Programs, Talent Placement & Management,and Academia.
              </div>
            </div>

            <div id="mission" className={styles.content_body_item}>
              <div className={styles.content_body_item_title}>Mission</div>
              <div className={styles.content_body_item_text}>
                <span className={styles.strong}>&apos;Just Know How&apos;</span>
                <br />
                <span className={styles.strong}>Q:EDU</span> equips and prepares individuals and
                institutions to &apos;Just Know How&apos; to contribute to a positive ethical
                integer and forward looking future, shaped by cutting edge technological
                innovations. Our Mission is to empower current and future generations to thrive
                within the rapidly evolving global landscape of technology.
              </div>
            </div>

            <div id="quantum-technology-market" className={styles.content_body_item}>
              <div className={styles.content_body_item_title}>Quantum Technology Market</div>
              <div className={styles.content_body_item_text}>
                {showMore ? (
                  <>
                    Quantum technology developments are moving beyond the lab and into the real
                    world. What was once a highly specialized research field is now on track to
                    reshape industries, including finance, healthcare, logistics, defense, and
                    beyond. The market, which includes quantum computing, communication, and
                    sensing, is expected to surpass{' '}
                    <span className={styles.strong}>$97 billion in 2035</span>. Key breakthroughs in
                    areas like error correction and system control are making quantum systems more
                    stable and closer to practical use. Backed by strong public and private
                    investment, and increasingly connected to fields like AI and cybersecurity,
                    quantum is quickly becoming a strategic priority. Companies that start building
                    internal knowledge and capability now won&apos;t just keep up; they&apos;ll
                    lead.{' '}
                    <span className={styles.more} onClick={() => setShowMore(!showMore)}>
                      Less
                    </span>
                  </>
                ) : (
                  <>
                    Quantum technology developments are moving beyond the lab and into the real
                    world. What was once a highly specialized research field is now on track to
                    reshape industries, including finance, healthcare, logistics, defense, and
                    beyond. The market, which includes quantum computing, communication, and
                    sensing, is expected to surpass{' '}
                    <span className={styles.strong}>$97 billion in 2035</span>{' '}
                    <span className={styles.more} onClick={() => setShowMore(!showMore)}>
                      Read more...
                    </span>
                  </>
                )}
              </div>
              <div className={styles.content_body_item_hint}>
                McKinsey & Company - The Year of Quantum: From Concept to Reality in 2025
              </div>
            </div>
          </div>

          <div className={styles.content_footer}>
            <Button
              size="l"
              variant="filled"
              className={styles.button}
              onClick={() => navigate('#plans')}
            >
              <div>CHOOSE YOUR Q:EDU PROGRAM PLAN</div>
              <Image src={ArrowIcon} alt="Arrow" draggable={false} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
